import { LocationStepFooter } from './steps/location/Footer';
import { DetailStepFooter } from './steps/detail/Footer';
import { MapStepFooter } from './steps/map/Footer';
import { ReviewStepFooter } from './steps/review/Footer';
import { FloorplanStepFooter } from './steps/floorplan/Footer';
import { ReadingStepFooter } from './steps/reading/Footer';
import { InventorizeStep } from './components/store';
import { NotFoundFooter } from '../not_found/components/NotFoundFooter';

export const renderFooterByStep = (newStep: InventorizeStep): React.VFC => {
  switch (newStep) {
    case InventorizeStep.LocationStep:
      return LocationStepFooter;
    case InventorizeStep.MapStep:
      return MapStepFooter;
    case InventorizeStep.FloorplanStep:
      return FloorplanStepFooter;
    case InventorizeStep.DetailStep:
      return DetailStepFooter;
    case InventorizeStep.ReadingStep:
      return ReadingStepFooter;
    case InventorizeStep.ReviewStep:
      return ReviewStepFooter;
    default:
      return NotFoundFooter;
  }
};
